import React from 'react';

import AnalyticsClient from '../clients/AnalyticsClient';

export const noop = () => Promise.resolve();

export default React.createContext<AnalyticsClient>({
  getAnalyticsWebClient: noop,
  markContentLoad: noop,
  page: noop,
  sendEventFromAnalyticsListener: noop,
  startUIViewedEvent: noop,
  track: noop,
  ui: noop,
});
